module.exports = __webpack_public_path__ + "static/media/purchaseswhite.e2299229.svg";